/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryTogglePinCommentRequest
 */
export interface RevisdomAPIViewModelsEntryTogglePinCommentRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryTogglePinCommentRequest
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsEntryTogglePinCommentRequest
     */
    isPinned?: boolean | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryTogglePinCommentRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryTogglePinCommentRequest(value: object): value is RevisdomAPIViewModelsEntryTogglePinCommentRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryTogglePinCommentRequestFromJSON(json: any): RevisdomAPIViewModelsEntryTogglePinCommentRequest {
    return RevisdomAPIViewModelsEntryTogglePinCommentRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryTogglePinCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryTogglePinCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isPinned': json['isPinned'] == null ? undefined : json['isPinned'],
    };
}

export function RevisdomAPIViewModelsEntryTogglePinCommentRequestToJSON(json: any): RevisdomAPIViewModelsEntryTogglePinCommentRequest {
    return RevisdomAPIViewModelsEntryTogglePinCommentRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryTogglePinCommentRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryTogglePinCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isPinned': value['isPinned'],
    };
}

